module.exports = __webpack_public_path__ + "static/comparison-media-query-vs-container-query-0bd269fceab7940a1114fc49cb677814.jpg";